import { useDealContext } from '@openx/components-deal/lib/utils/context/DealContext.tsx';
import type { IUseParticipantHooks } from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import { useBuyersFetch } from './useBuyersFetch.ts';
import { useDemandPartnersFetch } from './useDemandPartnersFetch.ts';

export const useParticipantHooks: IUseParticipantHooks = (props?: {
  demandPartnerId?: string | null;
  selectedBrandIds?: (string | null)[];
}) => {
  const { demandPartnerId } = props ?? {};

  const { useOnBehalfOfAccountId } = useDealContext();

  const onBehalfAccountId = useOnBehalfOfAccountId();

  const {
    mapById: demandPartners = {},
    loading: demandPartnersLoading,
    refetch: refetchDemandPartners,
  } = useDemandPartnersFetch({ account_uid: onBehalfAccountId });

  const { mapById: buyers = {}, loading: isBuyersLoading } = useBuyersFetch(demandPartnerId, onBehalfAccountId);

  return [
    {
      buyers,
      isBuyersLoading: isBuyersLoading,
    },
    {
      demandPartners,
      isDemandPartnersLoading: demandPartnersLoading,
      refetchDemandPartners: refetchDemandPartners,
    },
    {
      isBrandsLoading: false,
    },
  ];
};
